<template>
  <header class="header_box">
    <!-- logo -->
    <img class="header_logo" @click="erJIClick" src="../assets/logo.png" alt="" />
    <!-- 导航栏 begin -->
    <nav
      :class="
        $t('isLang') == 2 ? 'header_en_navigation header_navigation' : 'header_navigation'
      "
    >
      <ul>
        <!-- 母语传承 -->
        <li>
          <router-link active-class="click_link" :to="erjilu">
            <span>{{ $t("header.li1") }}</span>
            <div class="hover_box">
              <div class="hover_box_1">
                <p @click="erJIClick(1)">{{ $t("header.li9") }}</p>
                <p @click="erJIClick(2)">{{ $t("header.li7") }}</p>
              </div>
            </div>
          </router-link>
        </li>
        <!-- 二语习得 -->
        <li>
          <router-link active-class="click_link" :to="erYu">
            <span>{{ $t("header.li2") }}</span>
            <div class="hover_box">
              <div class="hover_box_1">
                <p @click="erJIClick(4)">{{ $t("header.li10") }}</p>
                <p @click="erJIClick(5)">{{ $t("header.li8") }}</p>
              </div>
            </div>
          </router-link>
        </li>
        <!-- 学分认证 -->
        <li>
          <router-link active-class="click_link" to="/olevel">
            <span>{{ $t("header.li4") }}</span>
            <div class="hover_box hover_box1">
              <div class="hover_box_1">
                <p>AP&IB&GCSE</p>
              </div>
            </div>
          </router-link>
        </li>
        <!-- 知行优势 -->
        <li>
          <router-link active-class="click_link" to="/advantage">
            <span>{{ $t("header.li3") }}</span>
          </router-link>
        </li>
        <!-- 博客 扩展阅读 -->
        <li>
          <router-link active-class="click_link" to="/further">
            <span>{{ $t("header.li5") }}</span>
          </router-link>
        </li>
        <!-- 免费试听 -->
        <li>
          <router-link active-class="click_link" to="/freetrial">
            <span> {{ $t("header.li6") }} </span>
          </router-link>
        </li>
      </ul>
    </nav>
    <!-- 导航栏 end -->

    <nav class="header_taget">
      <!-- 语言转换 begin -->

      <div class="header_langauge" @click="showClick">
        <img src="@/assets/index/wenA.png" alt="" />
        <div class="zyin">{{ lang == 1 ? "中文" : "Eng" }}</div>
        <i class="iconfont icon-xiala"></i>
        <div :class="isShow ? 'lang_box lang_boxSelect' : 'lang_box '">
          <div class="langTit" @click.stop.prevent="updateLang(2)">
            <div :class="lang == 1 ? 'clkBox' : 'clkBoxSelect'"></div>
            <div>English</div>
          </div>
          <div class="langTit" @click.stop.prevent="updateLang(1)">
            <div :class="lang == 2 ? 'clkBox' : 'clkBoxSelect'"></div>
            <div v-if="lang == 1">中&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;文</div>
            <div v-if="lang == 2">中&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;文</div>
          </div>
        </div>
      </div>

      <!-- 跳转 学员中心 begin -->
      <button class="header_button" @click="goToXueYuan">
        <div :class="$t('isLang') == 2 ? 'enSpan' : ''">{{ $t("header.button") }}</div>
        <i
          :class="$t('isLang') == 2 ? 'enI' : ''"
          class="iconfont icon-jiantou_xiangyou"
        ></i>
      </button>
      <!-- 跳转 学员中心 end -->
    </nav>
  </header>
</template>

<script>
import { toRefs, reactive, onMounted, inject, ref } from "vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
export default {
  name: "HeaderView",
  setup() {
    // 路由
    const router = useRouter();
    // 调用顶层 vueapp 方法 刷新路由
    const reload = inject("reload");
    const toggle = inject("toggle");
    // i18n 语言切换
    const { locale } = useI18n();
    // vuex 数据中心
    const store = useStore();
    // 本地数据中心
    const obj = reactive({
      lang: 1,
      erjilu: "/initiate",
      erYu: "/yct",
      xzho: "1",
      isShow: false,
    });

    const showClick = () => {
      obj.isShow = !obj.isShow;
    };
    // 语言切换 事件
    const updateLang = (e) => {
      switch (e) {
        case 1:
          localStorage.setItem("language", "zh");
          locale.value = "zh";
          obj.lang = 1;
          break;
        case 2:
          localStorage.setItem("language", "en");
          locale.value = "en";
          obj.lang = 2;
          break;
      }
      obj.isShow = true;
      toggle();
      reload();
    };
    const erJIClick = (index) => {
      switch (index) {
        case 1:
          router.push({
            path: "/initiate",
          });
          obj.erjilu = "/initiate";
          obj.xzho = "1";
          break;
        case 2:
          router.push({
            path: "/juvenile",
          });
          obj.erjilu = "/juvenile";
          obj.xzho = "2";
          break;
        case 4:
          router.push({
            path: "/yct",
          });
          obj.erYu = "/yct";
          obj.xzho = "4";
          break;
        case 5:
          router.push({
            path: "/hsk",
          });
          obj.erYu = "/hsk";
          obj.xzho = "5";
          break;
        default:
          router.push({
            path: "/home",
          });
          break;
      }
    };
    // 初始化生命周期
    onMounted(() => {
      obj.lang = localStorage.getItem("language") == "en" ? 2 : 1;
      let urlLang = window.location.href.split("lang=")[1];
      if (
        (urlLang != undefined) &
        (urlLang != null) &
        (urlLang != "undefined") &
        (urlLang != "")
      ) {
        const { locale } = useI18n();
        locale.value = urlLang;
      } else {
        locale.value = obj.lang == 2 ? "en" : "zh";
      }
    });
    const goToXueYuan = () => {
      let url = window.location.href;
      if (url.indexOf("zhixingchinese") != -1) {
        window.location.href = "https://student.zhixingchinese.com/";
      } else {
        window.location.href = "https://student.zhixingmandarin.com/";
      }
    };
    return {
      ...toRefs(obj),
      showClick,
      updateLang,
      erJIClick,
      goToXueYuan,
    };
  },
};
</script>
<style lang="less" scoped>
/deep/.el-dropdown-menu {
  border-radius: 20px;
}
.xzho {
  color: rgba(88, 130, 237, 1);
}
/deep/.el-dropdown-menu__item {
  text-align: center !important;
  display: block;
  width: 50px !important;
  height: 29px !important;
  padding: 0 17px 0 10px;
  .el-radio__label {
    font-size: 10px !important;
  }
  .el-radio__original {
    width: 12px;
    height: 12px;
  }
}
.header_box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background-color: rgba(88, 130, 237, 1);
  color: #fff;
  position: relative;
  .header_taget {
    position: absolute;
    top: 0;
    right: 75px;
    box-sizing: border-box;
    padding-top: 15px;
    display: flex;
  }
  // 跳转 学员中心 begin
  .header_button {
    cursor: pointer;
    min-width: 80px;
    height: 18px;
    opacity: 1;
    background: rgba(255, 255, 255, 1);
    border-radius: 18px;
    text-align: center;
    margin-left: 14px;
    position: relative;
    padding: 0 19px 0 7px;
    div {
      margin-top: 1px;
      height: 13px;
      line-height: 13px;
      font-size: 10px;
      font-weight: 400;
      color: rgba(88, 130, 237, 1);
    }
    .enSpan {
      font-size: 10px;
      font-weight: 300;
      left: 3px;
      letter-spacing: -0.005rem !important;
    }
    i {
      position: absolute;
      right: 4px;
      top: 50%;
      font-size: 15px;
      margin-top: -7px;
      color: rgba(88, 130, 237, 1);
    }
    // .enI {
    //   right: 5px;
    //   top: 50%;
    //   position: absolute;
    // }
  }
  // 跳转 学员中心 end

  // 头部语言切换 begin
  .header_langauge {
    cursor: pointer;
    width: 68px;
    height: 18px;
    border: 1px solid #fff;
    border-radius: 18px;
    position: relative;
    .lang_box {
      position: absolute;
      display: none;
      opacity: 0;
      transition: 0.35s;
      bottom: -53px;
      left: 0;
      width: 68px;
      height: 46px;
      border-radius: 2px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 1.07px 2.13px -0.53px rgba(0, 0, 0, 0.2),
        0px 0.53px 3px rgba(0, 0, 0, 0.12);
      box-sizing: border-box;
      padding: 0 1px;
      .langTit {
        width: 66px;
        height: 23px;
        display: flex;
        color: rgba(28, 28, 32, 1);
        font-size: 10px;
        font-weight: 400;
        line-height: 23px;
        padding-left: 25px;
        position: relative;
        .clkBox {
          position: absolute;
          top: 6px;
          left: 6px;
          width: 12px;
          height: 12px;
          box-sizing: border-box;
          border: 2px solid rgba(204, 204, 204, 1);
          border-radius: 50%;
        }
        .clkBoxSelect {
          position: absolute;
          top: 5.8px;
          left: 6px;
          width: 12px;
          height: 12px;
          box-sizing: border-box;
          border: 1.5px solid rgba(88, 130, 237, 1);
          border-radius: 50%;
        }
        .clkBoxSelect::after {
          content: "";
          position: absolute;
          top: 50%;
          left: 50%;
          margin-top: -3px;
          margin-left: -3px;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: rgba(88, 130, 237, 1);
        }
      }
      .langTit:nth-child(1) {
        border-bottom: 1px solid rgba(234, 234, 234, 1);
      }
    }
    .lang_box::after {
      content: "";
      position: absolute;
      top: -2.5px;
      left: 8px;
      width: 6px;
      height: 6px;
      background: rgba(255, 255, 255, 1);
      transform: rotate(45deg);
    }
    .lang_boxSelect {
      display: block !important;
      opacity: 1;
    }
    img {
      position: absolute;
      top: 2px;
      left: 7px;
      width: 12px;
      height: 15px;
    }
    .zyin {
      position: absolute;
      width: 20px;
      height: 13px;
      line-height: 13px;
      top: 3px;
      right: 22px;
      font-size: 10px;
      color: #fff;
    }
    i {
      position: absolute;
      top: 3px;
      right: 5px;
      font-size: 12px;
    }
  }
  // 头部语言切换 end

  // 头部logo begin
  .header_logo {
    position: absolute;
    left: 75px;
    top: 4.5px;
    width: 42px;
    height: 42px;
    opacity: 1;
    cursor: pointer;
  }
  // 头部logo end
  // 头部导航栏 begin
  .header_navigation {
    position: absolute;
    left: 240px;
    ul {
      display: flex;
      // width: 600px;
      padding: 0;
      margin: 0 auto;
      li:hover .hover_box {
        display: block;
      }
      .hover_box:hover {
        display: block;
      }
      li {
        flex: 1;
        width: 100px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        padding: 0;
        margin: 0 auto;
        box-sizing: border-box;
        position: relative;

        .hover_box {
          box-shadow: 0px 1px 5px rgba(34, 25, 25, 0.2);
          display: none;
          width: 120px;
          height: 63px;
          position: absolute;
          bottom: -63px;
          left: -10px;
          border-bottom-left-radius: 10px;
          border-bottom-right-radius: 10px;
          font-family: "Inter-Light" !important;
          .hover_box_1 {
            font-size: 16px;
            font-weight: 300;
            font-family: "Inter-Light" !important;
            width: 120px;
            height: 60px;
            background-color: #fff;
            position: absolute;
            bottom: 0;
            line-height: 21.95px !important;
            left: 0;
            box-sizing: border-box;
            padding-top: 7px;
            color: rgba(56, 56, 56, 1);
            border-bottom-left-radius: 10px;
            border-bottom-right-radius: 10px;
            white-space: nowrap;

            letter-spacing: 0 !important;
            p {
              margin: 0 0 3px 0;
            }
            p:hover {
              color: #466ed4;
            }
          }
        }
        .hover_box1 {
          width: 130px;
          height: 38px;
          position: absolute;
          bottom: -38px;
          left: -10px;
          .hover_box_1 {
            font-family: "Inter-Light" !important;
            font-weight: 300 !important;
            width: 130px !important;
            height: 35px !important;
            font-size: 16px;
            color: #383838;
            // letter-spacing: -0.003rem !important;
          }
        }
        outline: none;
        .el-dropdown {
          .el-dropdown-link:focus {
            outline: none;
          }
          span {
            outline: none;
          }
        }
        a {
          color: #fff !important;
          font-size: 15px;
          font-weight: 400;
          width: 100%;
          height: 100%;
          color: #fff;
          display: inline-block;
          letter-spacing: 0.005rem;
          padding: 0;
          vertical-align: top;
        }
        span {
          line-height: 50px;
          color: #fff;
          font-size: 15px;
        }
        .click_link {
          background-color: #466ed4;
        }
      }
    }
  }
  .header_en_navigation {
    left: 220px !important;
    ul {
      li:nth-child(1),
      li:nth-child(2) {
        span {
          // letter-spacing: -0.008rem !important;
        }
      }
      li {
        .hover_box_1 {
          font-family: "Inter-Light" !important;
          // letter-spacing: -0.008rem !important;
        }
        .hover_box1 {
          .hover_box_1 {
            font-family: "Inter-Light" !important;
          }
        }
        width: 100px !important;
        a {
          font-weight: 300 !important;
          letter-spacing: -0.003rem;
          font-size: 14px;
        }
        span {
          font-weight: 300 !important;
          // letter-spacing: -0.003rem;
          font-size: 14px;
        }
      }
    }
  }
  // 头部导航栏 eng
}
</style>
